import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';
import { VendorService } from '../proxy/controlling/controllers/vendor.service';
import { ViaSicfeTransportService } from '../proxy/controlling/controllers/via-sicfe-transport.service';
import { TransferTypeService } from '../proxy/controlling/controllers/transfer-type.service';
import { SaleMethodService } from '../proxy/controlling/controllers/sale-method.service';
import { ViaSapTransportService } from '../proxy/controlling/controllers/via-sap-transport.service';
import { MercosurCommonNameService } from '../proxy/controlling/controllers/mercosur-common-name.service';
import { DestinationIncoTermService } from '@general/proxy/general/controllers/destination-inco-term.service';
import { ExternalService } from '@general/proxy/general/controllers/external.service';
import { SaleClauseService } from '../proxy/controlling/controllers/sale-clause.service';
import { LocationService } from '@planning/proxy/planning/controllers/location.service';

import { SingleCustomsDeclarationMaterial } from '../single-customs-declaration-material/single-customs-declaration-material';
FieldBuilder.setNamespace('Controlling');

export const SINGLECUSTOMSDECLARATION_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .text('singleCustomsDeclarationNumber', 'Entity.SingleCustomsDeclaration.SingleCustomsDeclarationNumber')
    .required()
    .maxLength(8)
    .build(),
  FieldBuilder
    .number('year', 'Entity.SingleCustomsDeclaration.Year')
    .required()
    .build(),
  FieldBuilder
    .datetime('initialDate', 'Entity.SingleCustomsDeclaration.InitialDate')
    .required()
    .build(),
  FieldBuilder
    .datetime('finalDate', 'Entity.SingleCustomsDeclaration.FinalDate')
    .required()
    .build(),
  FieldBuilder
    .number('tolerance', 'Entity.SingleCustomsDeclaration.Tolerance')
    .decimal(2,10)
    .build(),
  FieldBuilder
    .number('tons', 'Entity.SingleCustomsDeclaration.Tons')
    .required()
    .decimal(2,10)
    .build(),
  FieldBuilder
    .number('tonsWarning', 'Entity.SingleCustomsDeclaration.TonsWarning')
    .required()
    .decimal(2,10)
    .build(),
  FieldBuilder.foreignKey(
    'dispatcherId',
    'Entity.ExternalService',
    ExternalService
  )
    .display('name')
    .keyField('id')
    .build(),
  FieldBuilder
    .checkbox('enabledCom', 'Entity.SingleCustomsDeclaration.EnabledCom')
    .build(),
  FieldBuilder.foreignKey(
    'carryWay',
    'Entity.ViaSICFETransport',
    ViaSicfeTransportService
  )
    .displayFromNested('viaSicfeTransport.name')
    .sortBy('viaSicfeTransport.name')
    .build(),
  FieldBuilder.foreignKey(
    'ncm',
    'Entity.MercosurCommonName',
    MercosurCommonNameService
  )
    .displayFromNested('mercosurCommonName.name')
    .sortBy('mercosurCommonName.name')
    .build(),
  FieldBuilder
    .text('customsHouseDocumentType', 'Entity.SingleCustomsDeclaration.CustomsHouseDocumentType')
    .maxLength(1)
    .build(),
  FieldBuilder.foreignKey(
    'sapCarryWay',
    'Entity.ViaSAPTransport',
    ViaSapTransportService
  )
    .displayFromNested('viaSapTransport.name')
    .sortBy('viaSapTransport.name')
    .build(),
  FieldBuilder.foreignKey(
    'salesMod',
    'Entity.SaleMethod',
    SaleMethodService
  )
    .displayFromNested('saleMethod.name')
    .sortBy('saleMethod.name')
    .required()
    .build(),
  FieldBuilder.foreignKey(
    'deliveryType',
    'Entity.TransferType',
    TransferTypeService
  )
    .displayFromNested('transferType.name')
    .sortBy('transferType.name')
    .required()
    .build(),
  FieldBuilder.foreignKey(
    'incoTerms',
    'Entity.SaleClause',
    SaleClauseService
  )
    .display('name')
    .keyField('id')
    .required()
    .build(),
  FieldBuilder
    .checkbox('noPulp', 'Entity.SingleCustomsDeclaration.NoPulp')
    .build(),
  FieldBuilder.foreignKey(
    'vendorId',
    'Entity.Vendor',
    VendorService
  )
    .displayFromNested('vendor.fantasyName')
    .sortBy('vendor.fantasyName')
    .build(),
  FieldBuilder.foreignKey( 
    'destinationIncoTermId',
    'Entity.SingleCustomsDeclaration.DestinationIncoTerm',
    DestinationIncoTermService
  )
    .required()
    .display('name')
    .keyField('id')
    .build(),
  FieldBuilder.foreignKey( 
    'plantLocationId',
    'Entity.Plant',
    LocationService
  )
    .queryFilter({ locationTypeEntityName: 'Mill' })
    .required()
    .display('name')
    .keyField('id')
    .build(),
];

export const SINGLECUSTOMSDECLARATION_CONFIG = {
  entityName: 'SingleCustomsDeclaration',
  localizationKey: 'Controlling::Entity.SingleCustomsDeclaration',
  fields: SINGLECUSTOMSDECLARATION_FIELDS,
  permission: 'ControllingLiquidations.SingleCustomsDeclarations',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Controlling + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.Liquidations + MENU_NAME_SUFFIX,
  children: [
    {
      entityName: 'SingleCustomsDeclarationMaterial',
      foreignKeyField: 'singleCustomsDeclarationId',
      localizationKey: 'Controlling::Entity.SingleCustomsDeclarationMaterial',
      component: SingleCustomsDeclarationMaterial,
    },
  ],
};
